import Vue from 'vue';
import FontFaceObserver from 'fontfaceobserver';
import { gsap } from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import zenScroll from 'zenscroll';
import imagesLoaded from 'imagesloaded';

gsap.registerPlugin(ScrollTrigger);

Vue.component('page-header-component', {
    data() {
        return {
            initialized: false
        };
    },

    mounted() {
        const font = new FontFaceObserver('AmarelaStencil');

        Vue.nextTick(() => {

            this.initHeaderScrollTrigger();

            font.load(null, 500).then(() => {
                imagesLoaded(this.$el, () => {
                    gsap.delayedCall(0.8, () => {
                        this.initHeaderMask();
                    });
                });
            }, () => {
                imagesLoaded(this.$el, () => {
                    gsap.delayedCall(0.8, () => {
                        this.initHeaderMask();
                    });
                });
            });
        });

        gsap.delayedCall(2.2, () => {
            if (!this.initialized) {
                this.initHeaderMask();
            }
        })
    },

    methods: {
        initHeaderScrollTrigger() {
            if (window.matchMedia("(min-width: 1024px)").matches) {
                this.headerScrollTrigger = ScrollTrigger.create({
                    trigger: '.pageheader-container',
                    start: 'bottom bottom-=120px',
                    onEnter: () => {
                        gsap.to(".hamburger__line", { duration: 0.8, backgroundColor: '#1B4540', ease: 'power4.out' });
                        gsap.to([".current-language", ".language-selector a"], { duration: 0.8, color: '#1B4540', ease: 'power4.out' });
                        gsap.to([".language-selector__arrow"], { duration: 0.8, stroke: '#1B4540', ease: 'power4.out' });
                        gsap.to(".header__logo-desktop path", {
                            duration: 0.8, fill: '#1B4540', ease: 'power4.out', onComplete: () => {
                                this.$parent.lightHeader = false;
                            }
                        });
                    },
                    onLeaveBack: () => {
                        gsap.to(".hamburger__line", { duration: 0.8, backgroundColor: '#fff', ease: 'power4.out' });
                        gsap.to([".current-language", ".language-selector a"], { duration: 0.8, color: '#fff', ease: 'power4.out' });
                        gsap.to([".language-selector__arrow"], { duration: 0.8, stroke: '#fff', ease: 'power4.out' });
                        gsap.to(".header__logo-desktop path", {
                            duration: 0.8, fill: '#fff', ease: 'power4.out', onComplete: () => {
                                this.$parent.lightHeader = true;
                            }
                        });
                    },
                });
            } else {
                gsap.set('.header-bar', { y: '-100%' });

                this.headerScrollTrigger = ScrollTrigger.create({
                    trigger: '#app',
                    start: 'top top-=140px',
                    onEnter: () => {
                        gsap.to(".header-bar", { duration: 0.8, y: '0%', ease: 'power4.out' });
                        gsap.to(".hamburger__line", { duration: 0.8, backgroundColor: '#1B4540', ease: 'power4.out' });
                        gsap.to([".current-language", ".language-selector a"], { duration: 0.8, color: '#1B4540', ease: 'power4.out' });
                        gsap.to([".language-selector__arrow"], { duration: 0.8, stroke: '#1B4540', ease: 'power4.out' });
                        gsap.to(".header__logo-mobile .fill", {
                            duration: 0.8, fill: '#1B4540', ease: 'power4.out', onComplete: () => {
                                this.$parent.lightHeader = false;
                            }
                        });
                    },
                    onLeaveBack: () => {
                        gsap.to(".header-bar", { duration: 0.8, y: '-100%', ease: 'power4.out' });
                        gsap.to(".hamburger__line", { duration: 0.8, backgroundColor: '#fff', ease: 'power4.out' });
                        gsap.to([".current-language", ".language-selector a"], { duration: 0.8, color: '#fff', ease: 'power4.out' });
                        gsap.to([".language-selector__arrow"], { duration: 0.8, stroke: '#fff', ease: 'power4.out' });
                        gsap.to(".header__logo-mobile .fill", {
                            duration: 0.8, fill: '#fff', ease: 'power4.out', onComplete: () => {
                                this.$parent.lightHeader = true;
                            }
                        });
                    },
                });
            }
        },

        destroyHeaderScrollTrigger() {
            if (this.headerScrollTrigger) {
                this.headerScrollTrigger.kill();
            }
        },

        initHeaderMask() {
            if (this.initialized) {
                return;
            }

            this.initialized = true;

            const trigger = this.$el.querySelector('#container-2')

            if (trigger) {
                const heading = this.$el.querySelector('h1#page-title');
                const pageTitle = this.$el.querySelector('.--masked .page-title');

                window.requestAnimationFrame(() => {
                    const box = heading.getBoundingClientRect();
                    gsap.set(this.$refs['mask'], { paddingTop: `${box.top}px` });
                    gsap.set(heading, {
                        autoAlpha: 0,
                    });

                    this.maskTl = gsap.timeline({
                        scrollTrigger: {
                            trigger: "#container-2",
                            start: "top top",
                            end: "+=100%",
                            pinSpacing: false,
                            pin: '#container-2 #mask-holder',
                            scrub: true
                        }
                    });

                    this.maskTl.fromTo(pageTitle, { backgroundPosition: '50% 0px' }, { backgroundPosition: '50% -250px', ease: 'none' });

                    let height = trigger.offsetHeight;

                    gsap.delayedCall(0.2, () => {
                        zenScroll.toY(height, 2000);
                    });
                });
            }
        }
    },

    beforeDestroy() {
        gsap.set('.header-bar', { clearProps: 'all' });

        this.destroyHeaderScrollTrigger();
    },
});
